goog.provide("shadow.js.shim.module$src$svg$wpp$content$action_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$action_svg");
shadow.js.shim.module$src$svg$wpp$content$action_svg = shadow.js.nativeProvides["src/svg/wpp/content/action.svg"] = shadow$bridge("src/svg/wpp/content/action.svg");
module$shadow_js_shim_module$src$svg$wpp$content$action_svg.default = shadow.js.shim.module$src$svg$wpp$content$action_svg;
